


export const createWidgetMutatuion=(data)=>`mutation {
    createTypeWidget(createTypeWidgetInput:{name:"${data.name}",icon:"${data.icon}",frontOffice:"${data.frontOffice}",backOffice:"${data.backOffice}",color:"red",is_active:${data.is_active}})
    {
       name
       color
     }
    }`

export const toggleWidgetStatusMutation=(id)=>`mutation {
    toggleTypeWidgetStatus(id:${id}){
      is_active
      color
    }
    }`    


export const deleteWidgetMutation=(id)=>`mutation{
  removeTypeWidget(id:${id}){
    color
   name
  }
 }`


 export const updatewidgetMutation=(id,updateDto)=>`mutation{
  updateTypeWidget(id:${id},updateTypeWidgetInput:{name:"${updateDto.name}",color:"${updateDto.color}",is_active:${updateDto.is_active},frontOffice:"${updateDto.frontOffice}",backOffice:"${updateDto.backOffice}",icon:"${updateDto.icon}"})
  { 
    
    id
    name
    color 
    is_active
    
   }
}`


export const createWidgetMutationInfo =(createDto)=>`
mutation{
  createWidget(createWidgetInput:{type_id:${createDto.type_id},                 
                                  is_active:${createDto.is_active},
                                  public_APi:"empty",
                                  widgetDes:"empty",
                                 Token:"${createDto.Token}",
                                 endPoint:"${createDto.endPoint}",
                                 is_reachebale:${createDto.is_reachebale},
                                 api_host:"${createDto.api_host}"}){
       endPoint
       Token
       
    }
}
`



export const setWidgetToreachableMutation =(type_id,widget_id)=>`mutation{

  toggleReachabaleWidget(type_id:${type_id},widget_id:${widget_id})
    {
      id
   
     }
  
  }`



export const toggleWidgetCreedStatusMutation=(id)=>`mutation{

  toggleWidgetStatus(id:${id})
   {
      is_active
    }
 
 }`

export const deleteWidgetCreedMutation=(id)=>`
mutation{
  deleteWidget(id:${id}){
    is_active
    public_APi
  }
  }
`


export const updatewidgetCreedMutation=(id,updateDto)=>`
mutation{
 
  updateWidget(id:${id},updateWidgetInput:{is_active:${updateDto.is_active},is_reachebale:${updateDto.is_reachebale},widgetDes:"empty",Token:"${updateDto.Token}",endPoint:"${updateDto.endPoint}",api_host:"${updateDto.apiHost}",public_APi:"empty"}){
    widgetDes
    Token
    public_APi
   }

}

`
